import { FC } from 'react';

import { Box } from '@material-ui/core';

import { cmpStyle } from './styles';

export const Ellipse: FC = ({ children }) => {
  const classes = cmpStyle();

  return <Box className={classes.root}>{children}</Box>;
};
